// extracted by mini-css-extract-plugin
export default {"tag":"MGTag_tag__pyJ3E","label":"MGTag_label__YFluz","close":"MGTag_close__XnR4G"};